import * as actionTypes from './actionTypes';
import { OperatorModel } from '@app/src/views/CipReport/filter/models/Operator';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  data: OperatorModel;
  isFetching: boolean;
  errorMessage: string;
  errorRol?: boolean;
}

const initialState = {
  data: {
    code: null,
    message: '',
    operator: []
  },
  isFetching: false,
  errorMessage: '',
  errorRol: false
};

export const operator = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_OPERATOR_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.FETCH_OPERATOR_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.errorMessage,
        errorRol: action.errorRol
      };
    case actionTypes.FETCH_OPERATOR_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: '',
        errorRol: false
      };
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
